module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-icon.6c0a6943.png";